var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from "react";
import { Cards } from ".";
var ProjectList = /** @class */ (function (_super) {
    __extends(ProjectList, _super);
    function ProjectList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProjectList.prototype.render = function () {
        var projects = this.props.projects;
        return (React.createElement("div", null,
            React.createElement("h4", { className: "h4" }, "Projects"),
            React.createElement("div", null,
                React.createElement("p", null, "The following projects are at this event:"),
                React.createElement(Cards, { emptyMessage: "There are no projects for this event.", items: projects
                        ? projects.map(function (project) {
                            return {
                                id: project.Id,
                                name: project.Name,
                                description: project.Description || "",
                                link: "".concat(document.location.pathname).concat(project.Id),
                                icon: project.LogoUrl || require("../../images/icon-project.png"),
                                tag: project.Status
                            };
                        })
                        : null }))));
    };
    return ProjectList;
}(React.PureComponent));
export default ProjectList;
